import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSupportContent } from '../../config/queries'
import NotFound from '../Error/NotFound'
import { isSupportSectionSlug } from './sections'
import SupportLayout from './SupportLayout'
import SupportArticleContent from './SupportArticleContent'
import SupportFaqAccordion from './SupportFaqAccordion'

const SupportSectionPage = () => {
  const { section: sectionParam } = useParams()
  const { t } = useTranslation()
  const { data, isPending } = useSupportContent()

  if (!sectionParam || !isSupportSectionSlug(sectionParam)) {
    return <NotFound />
  }

  const section = sectionParam
  const articles = data?.articlesBySection[section] ?? []
  const intro = articles.find((a) => !a.parentId)
  const sectionFaqs =
    data?.faqEntries.filter((entry) => entry.section === section) ?? []

  if (isPending) return null

  if (!intro) {
    return (
      <SupportLayout
        section={section}
        articles={articles}
        title={t(`support.sections.${section}.title`)}
      >
        <p className='text-muted-foreground'>{t('support.no-intro')}</p>
        <SupportFaqAccordion entries={sectionFaqs} />
      </SupportLayout>
    )
  }

  return (
    <SupportLayout
      section={section}
      articles={articles}
      title={t(`support.sections.${section}.title`)}
    >
      <article className='flex flex-col gap-10'>
        <div>
          <SupportArticleContent content={intro.content} />
        </div>
        <SupportFaqAccordion entries={sectionFaqs} />
      </article>
    </SupportLayout>
  )
}

export default SupportSectionPage
